import CheckBox from "components/check-box";
import GrayCard from "components/gray-card";
import Typography from "components/typography";

import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  stores: { name: string; link: string }[];
  onChange: (stores: { name: string; link: string }[]) => void;
}
const VideoStores = ({ stores, onChange }: IProps) => {
  const StoreActive = (name: string) => {
    const isActive = stores.findIndex((store) => store.name === name);
    return isActive === -1 ? false : true;
  };
  const AddStore = (store: string) => {
    if (!StoreActive(store)) {
      onChange([...stores, { name: store, link: "" }]);
    }
  };

  const RemoveStore = (store: string) => {
    if (StoreActive(store)) {
      onChange(stores.filter((s) => s.name !== store));
    }
  };
  return (
    <GrayCard title="Music Video Stores">
      <Typography mb="0.8" weight="medium" color={Colors.grey400}>
        Select stores you would like to distribute your release to
      </Typography>
      <CheckItem>
        <CheckBox
          defaultState={StoreActive("apple")}
          onChange={() => {
            if (StoreActive("apple")) {
              RemoveStore("apple");
            } else {
              AddStore("apple");
            }
          }}
        />
        <Typography size="s" color={Colors.grey400}>
          Apple Music
        </Typography>
      </CheckItem>
      <CheckItem>
        <CheckBox
          onChange={() => {
            if (StoreActive("tial")) {
              RemoveStore("tidal");
            } else {
              AddStore("tidal");
            }
          }}
          defaultState={StoreActive("tidal")}
        />
        <Typography size="s" color={Colors.grey400}>
          Tidal
        </Typography>
      </CheckItem>
      <CheckItem>
        <CheckBox
          onChange={() => {
            if (StoreActive("vevo")) {
              RemoveStore("vevo");
            } else {
              AddStore("vevo");
            }
          }}
          defaultState={StoreActive("vevo")}
        />
        <Typography size="s" color={Colors.grey400}>
          VEVO
        </Typography>
      </CheckItem>
    </GrayCard>
  );
};

export default VideoStores;

const CheckItem = styled.div`
  display: grid;
  grid-template-columns: 3% 96%;
  align-items: center;
  justify-content: space-between;
  margin-top: 1.6rem;
`;
